<template>
  <popup
    :opened="popupState > -1"
    @close="$emit('close')"
  >
    <!-- Screen to ask a confirmation to close current evaluation -->
    <div
      v-if="popupState == 0"
      class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
    >
      <h3 class="mb-10">
        <slot name="title" />
      </h3>
      <h6 class="text-indigo-600 mb-5">
        <slot name="message" />
        <br>Cette suppression sera définitive et irrévocable.
      </h6>
      <h6
        v-if="warningCondition"
        class="text-pink-600 mb-10 italic"
      >
        <slot name="warning" />
      </h6>

      <div class="w-full flex space-x-5 justify-center">
        <action-button 
          class=" relative flex flex-row"
          border-color="border-pink-600"
          text-color="text-pink-600"
          bg-color="bg-pink-300"
          libelle="Annuler"
          :uppercase="true"
          @clickAction="$emit('close')"
        />
        <action-button 
          class=" relative flex flex-row"
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          libelle="Supprimer"
          :uppercase="true"
          type-shadow="shadow-pink"
          @clickAction="$emit('confirmation')"
        />
      </div>
    </div>
    <!-- END Screen to ask a confirmation to close current evaluation -->

    <!-- Screen to confirm the close -->
    <div 
      v-if="popupState == 1"  
      class="mx-5 xl:mx-16 2xl:mx-20 my-8 w-auto h-auto"
    >
      <h3 class="mb-10 text-pink-600">
        <slot name="confirmTitle" />
      </h3>
      <h6 class="text-indigo-600 mb-10">
        <slot name="confirmMessage" />
      </h6>
      <div class="w-full flex justify-center">
        <illustration
          name="basket"
          class="w-full"
        />
      </div>
    </div>
    <!-- END Screen to confirm the close -->
  </popup>
</template>

<script>
import Popup from './../Popup.vue';
import Illustration from '../Illustration.vue';
import ActionButton from '../ActionButton.vue';

export default {
  components:{
    Popup,
    Illustration,
    ActionButton
  },

  props:{
    popupState:{
      type: Number,
      required: true
    },
    warningCondition:{
      type:Boolean,
      required:false,
      default:false
    }
  }
};
</script>